// extracted by mini-css-extract-plugin
export default {"suggestions_container":"Suggestions_suggestions_container__zFkLn","suggestions_img_container":"Suggestions_suggestions_img_container__NQ0RU"};